<template>
    <!-- Add Reminder Modal -->
    <div class="modal fade" id="addReminderModal" ref="addReminderModal" tabindex="-1" aria-labelledby="reminderModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="reminderModalLabel">
                        <template v-if="reminder!=null">Edit</template><template v-else>Add</template> Reminder
                        <template v-if="quotation"> for {{quotation.name}}</template>
                    </h5>
                    <button type="button" class="btn-close"  data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>

                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="javascript:void(0);" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation" name="addReminder">
                        <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                            <div class="row" v-if="!quotation">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Sales Order</label>
                                        <template v-if="reminder && form.order">#{{reminder.order.order_number}}</template>
                                        <template v-else>
                                            <v-select label="text" :filterable="false"
                                                      v-model="form.order"
                                                      :options="orders"
                                                      @search="onOrderSearch"
                                                      @input="onOrderSelect"
                                                      @selected="onOrderSelect"
                                                      @deselected ="onOrderDeSelect">
                                                <template slot="no-options">
                                                    type to search orders..
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-html="'#'+option.order_number">
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center" v-html="'#'+option.order_number">
                                                    </div>
                                                </template>
                                            </v-select>
                                        </template>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Purchase Order</label>
                                        <template v-if="reminder && form.purchase_order">#{{reminder.purchase_order.po_number}}</template>
                                        <template v-else>
                                            <v-select label="text" :filterable="false"
                                                      v-model="form.purchase_order"
                                                      :options="purchase_orders"
                                                      @search="onPurchaseOrderSearch"
                                                      @input="onPurchaseOrderSelect"
                                                      @selected="onPurchaseOrderSelect"
                                                      @deselected ="onPurchaseOrderDeSelect">
                                                <template slot="no-options">
                                                    type to search orders..
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-html="'#'+option.po_number">
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center" v-html="'#'+option.po_number">
                                                    </div>
                                                </template>
                                            </v-select>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="!quotation">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Customer</label>
                                        <CustomerSelect :customer="form.customer" :multiple="false" @customerSelectedEvent="customerSelected"></CustomerSelect>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Vendor</label>
                                        <VendorSelect :vendor="form.vendor" :multiple="false" @vendorSelectedEvent="vendorSelected"></VendorSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="!quotation">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Quotation</label>
                                        <QuotationSelect :quotation="form.quotation" :multiple="false" @quotationSelectedEvent="quotationSelected"></QuotationSelect>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-3">
                                        <label class="form-label">Title</label>
                                        <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                                            <input type="text" class="form-control" v-model="form.title" />
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="form-label">Description</label>
                                    <textarea class="form-control" style="height: 80px" v-model="form.details"></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Due Date</label>
                                        <ValidationProvider name="Due Date" rules="required" v-slot="{ errors }">
                                            <date-picker v-model="form.due_date" format="MM/DD/YYYY" valueType="format"></date-picker>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                <div class="mt-3">
                                    <label class="form-label">Due Time</label>
                                    <date-picker v-model="form.due_time" format="HH:mm" value-type="format" :minute-step="15" type="time" :editable="false" placeholder="All Day"></date-picker>
                                </div>
                            </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Assign To</label>
                                        <ValidationProvider name="Assign To" rules="required" v-slot="{ errors }">
                                            <!--<select class="form-control" v-model="form.assign_ids" multiple="">
                                                <option :value="null">Select</option>
                                                <option v-for="(admin, index) in admins" :value="admin.id">
                                                    {{ admin.name }}
                                                </option>
                                            </select>-->
                                            <v-select label="text" :filterable="true" multiple=""
                                                      v-model="form.assign_admins"
                                                      :options="admins">
                                                <template slot="no-options">
                                                    type to search admins..
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-html="option.name">
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center" v-html="option.name">
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="mt-3">
                                        <label class="form-label">Upload</label>
                                        <vue-dropzone :options="dropzoneOptions"
                                                      :id="'item-dropzone-attach'"
                                                      v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                        </vue-dropzone>
                                        <div>
                                            <template v-if="attached_file">
                                                <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_1'">
                                                    <img v-if="attached_file.url && (attached_file.file_ext.toLowerCase() == 'png' || attached_file.file_ext.toLowerCase() == 'jpeg' || attached_file.file_ext.toLowerCase() == 'jpg')"
                                                         :src="attached_file.url" style="width:70px;height:70px">
                                                    {{attached_file.filename ? attached_file.filename : attached_file.attach_link}}
                                                    <a href="javascript:void(0)" class="trash_btn"
                                                       @click="deleteAttachFile()"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Priority</label>
                                        <select class="form-select" v-model="form.priority_id">
                                            <option :value="null">Select</option>
                                            <option v-for="(item, index) in priorities" :value="item.id">
                                                {{ item.priority_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Status</label>
                                        <select class="form-select" v-model="form.status">
                                            <option value="0">Open</option>
                                            <option value="1">Closed</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 text-end">
                                <button type="submit" :disabled="loading" class="btn btn-primary fw-semibold fs-14 px-4">Save</button>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';
import axios from "axios";
import DatePicker from "vue2-datepicker";
import {mapActions, mapGetters, mapState} from "vuex";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import moment from "moment";

import {debounce} from 'lodash';
import CustomerSelect from "./CustomerSelect";
import VendorSelect from "./VendorSelect";
import QuotationSelect from "./QuotationSelect";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "AddReminder",
    props:['reminder', 'loading', 'quotation', 'user'],
    components:{
        ValidationObserver, ValidationProvider,
        vueDropzone: vue2Dropzone,
        DatePicker,
        CustomerSelect,
        VendorSelect,
        QuotationSelect
    },
    created() {
    },
    mounted() {
        this.getReminderSettings();

        let self = this;

        $("#addReminderModal").on('show.bs.modal', () => {
            if(self.reminder) {
                self.form.order_id = self.reminder.order_id;
                self.form.order = self.reminder.order;

                self.form.customer_id = self.reminder.customer_id;
                self.form.customer = self.reminder.customer;

                self.form.vendor_id = self.reminder.vendor_id;
                self.form.vendor = self.reminder.vendor;

                self.form.purchase_order_id = self.reminder.purchase_order_id;
                self.form.purchase_order = self.reminder.purchase_order;

                if(self.reminder.quotation) {
                    let name  = '#' + self.reminder.quotation.quotation_number;
                    if(self.reminder.quotation.quote_name && self.reminder.quotation.quote_name !== '') {
                        name += ` (${self.reminder.quotation.quote_name})`;
                    }
                    self.reminder.quotation.name = name;
                    self.reminder.quotation.text = name;
                    self.reminder.quotation.html = name;
                }

                self.form.quotation_id = self.reminder.quotation_id;
                self.form.quotation = self.reminder.quotation;

                self.form.title = self.reminder.title;
                self.form.details = self.reminder.details;
                self.form.due_date = self.reminder.due_date ? self.formatDate(self.reminder.due_date) : null;

                self.form.due_time =  self.reminder.due_time;
                self.form.due_time_is_all_day = self.reminder.due_time_is_all_day;

                //self.form.assign_ids = self.reminder.assign_ids;
                self.form.assign_ids = [];
                self.form.assign_admins = [];
                if(self.reminder.admins) {
                    self.reminder.admins.forEach((x) => {
                        self.form.assign_ids.push(x.id);
                        self.form.assign_admins.push(x);
                    });
                }
                self.form.priority_id = self.reminder.priority_id;
                self.form.status = self.reminder.status;

                if(self.reminder.attachments && self.reminder.attachments.length) {
                    self.form.media_id = self.reminder.attachments[0].uploaded_media_id;

                    self.attached_file = self.reminder.attachments[0];
                }
            } else {
                if(this.user) {
                    self.form.assign_ids.push(this.user.id);
                    self.form.assign_admins.push(this.user);
                }

                self.form.due_date = moment().format("MM/DD/YYYY");
            }

            if(self.quotation) {
                self.form.quotation_id = self.quotation.id;
                self.form.quotation = self.quotation;
            }
        });

        $(this.$refs.addReminderModal).on('hidden.bs.modal', function () {
            self.form = {
                order: null,
                order_id: null,
                order_type: 'so',
                customer: null,
                customer_id: null,
                vendor: null,
                vendor_id: null,
                purchase_order: null,
                purchase_order_id: null,
                quotation: null,
                quotation_id: null,
                title: null,
                details: null,
                due_date: null,
                due_time: null,
                due_time_is_all_day: null,
                assign_ids: [],
                assign_admins: [],
                priority_id: null,
                status: 0,
                media_id: null
            };

            self.attached_file = null;

            self.$refs.formValidation.reset();
        });
    },
    data(){
        return {
            form: {
                order: null,
                order_id: null,
                order_type: 'so',
                customer: null,
                customer_id: null,
                vendor: null,
                vendor_id: null,
                purchase_order: null,
                purchase_order_id: null,
                quotation: null,
                quotation_id: null,
                title: null,
                details: null,
                due_date: null,
                due_time: null,
                due_time_is_all_day: null,
                assign_ids: [],
                assign_admins: [],
                priority_id: null,
                status: 0,
                media_id: null
            },
            admins: [],
            priorities: [],
            orders: [],
            purchase_orders: [],
            customers: [],
            vendors: [],
            quotations: [],
            dropzoneOptions: {
                url: window.route('medias.store'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            attached_file: null
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        quotationSelected(event) {
            console.log(event);
            if(event != null) {
                this.form.quotation = event;
                this.form.quotation_id = event.id;
            } else {
                this.form.quotation = null;
                this.form.quotation_id = null;
            }
        },
        customerSelected(event){
            console.log(event);
            if(event != null) {
                this.form.customer = event;
                this.form.customer_id = event.id;
            } else {
                this.form.customer = null;
                this.form.customer_id = null;
            }
        },
        vendorSelected(event){
            console.log(event);
            if(event != null) {
                this.form.vendor = event;
                this.form.vendor_id = event.id;
            } else {
                this.form.vendor = null;
                this.form.vendor_id = null;
            }
        },
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);

                if(this.reminder) {
                    return axios.put(window.route('dashboard.reminders.update', {id: this.reminder.id}), this.form,{

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage(data.data);
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('updatedEvent', data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                } else {
                    return axios.post(window.route('dashboard.reminders.store'), this.form,{

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage(data.data);
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('addedEvent', data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                }
            });
        },
        getReminderSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.get(window.route('dashboard.tasks.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.admins = _.cloneDeep(data.data.admins);
                        this.priorities = _.cloneDeep(data.data.priorities);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        afterUploadComplete(file, response) {
            this.form.media_id = response.data.media.id;
            let media = _.cloneDeep(response.data.media);
            media['url'] = response.data.url;
            this.attached_file = _.cloneDeep(media);
        },
        deleteAttachFile() {
            this.form.media_id = null;
            this.attached_file = null;
        },
        onOrderSelect(event){
            if (event) {
                this.form.order_id = event.id;
            } else {
                this.form.order_id = null;
            }
        },
        onOrderDeSelect(event){
            this.form.order_id = null;
        },
        onOrderSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchOrder(loading, search, this);
            }
        },
        searchOrder: debounce((loading, search, vm) => {
            let url = window.route('orders.search', {searchTerm: search});
            return axios.get(url,  {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.orders = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),


        onPurchaseOrderSelect(event){
            if (event) {
                this.form.purchase_order_id = event.id;
            } else {
                this.form.purchase_order_id = null;
            }
        },
        onPurchaseOrderDeSelect(event){
            this.form.purchase_order_id = null;
        },
        onPurchaseOrderSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchPurchaseOrder(loading, search, this);
            }
        },
        searchPurchaseOrder: debounce((loading, search, vm) => {
            let url = window.route('po.search', {searchTerm: search});
            return axios.get(url,  {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.purchase_orders = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {
        'form.assign_admins': {
            handler: function (after, before) {
                this.form.assign_ids = [];
                if(after) {
                    after.forEach((x) => {
                        this.form.assign_ids.push(x.id);
                    })
                }
            },
            deep: true
        },
    }
}
</script>

<style scoped>

</style>
